module.exports = __webpack_public_path__ + "img/lt_rb.254f652d.png";